import * as React from 'react';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { ColorPalette, TypographySettings } from '../config';

export function ContentTitle({ children, sx = {}, color }: { children?: React.ReactNode; sx?: TypographyProps['sx']; color?: string }) {
  return (
    <Typography
      variant="h3"
      sx={{
        ...sx,
        color: color || ColorPalette.DefaultTextColor,
        fontSize: TypographySettings.DefaultFontSize,
        fontFamily: TypographySettings.AlternativeFontFamily,
        fontWeight: TypographySettings.AlternativeFontSemiBold,
      }}
    >
      {children}
    </Typography>
  );
}
